import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const Footer = () => {
  return (
    <>
      <footer className="text-center text-gray-200 bg-cyan-600">
        <div className="justify-center p-4">
          <div className="flex justify-center text-center p-4">
            Made With ❤️‍🔥 By Nishan Kadel.
          </div>
          <hr className="mb-2" />© {moment(Date.now()).format("YYYY")} Copyright
          |<Link to="/"> Write-Me</Link>
        </div>
      </footer>
    </>
  );
};

export default Footer;
